'use client';

/**
 * SysObeyaKpiHighestCcCard — Complexity Hotspots KPI tile.
 *
 * Slices `response.totals.highest_cc` from the system_obeya_view
 * high_cc_functions call. Hero number is the worst-offender CC score
 * across the codebase.
 *
 * @see klyde_edge/ui_config/composition/cards/system_obeya.py — content_key="sys_obeya_kpi_highest_cc"
 * @see klyde_edge/ui_config/labels/system_obeya.py — high_cc_kpi_highest_cc_*
 */

import { Flame } from 'lucide-react';
import { useSystemObeyaView } from './use-system-obeya-view';
import { KpiTile, fmt } from './kpi-tile';

interface Props {
  view_name?: string;
}

export function SysObeyaKpiHighestCcCard({ view_name = 'high_cc_functions' }: Props) {
  const { data, isLoading, queryKey } = useSystemObeyaView(view_name);
  const L = data?.labels ?? {};
  const t = data?.totals ?? {};
  return (
    <KpiTile
      contentKey="sys_obeya_kpi_highest_cc"
      label={L.high_cc_kpi_highest_cc_label ?? ''}
      Icon={Flame}
      value={isLoading ? '…' : fmt(t.highest_cc)}
      queryKey={queryKey}
    />
  );
}
